import { CLIENT_AIRCRAFT_OWNERSHIP_TYPES, Client } from '@models/client.model';

const CLIENT_ID_PREFIX = 'CL-';
export const getClientID = (index: number) => `${CLIENT_ID_PREFIX}${index}`;

export const mockClients: Client[] = [
  {
    documentID: getClientID(1),
    primaryContact: {
      isPrimary: true,
      title: 'Mr.',
      firstName: 'John',
      lastName: 'Doe',
      address: '123 Aviation Way, Some City, Some Country',
      email: 'john.doe@example.com',
      phone: '+1234567890',
      jobTitle: 'CEO',
      company: {
        name: 'Acme Aviation',
        address: '123 Aviation Way, Some City, Some Country',
        website: 'https://acmeaviation.com',
      },
    },
    contacts: [
      {
        isPrimary: true,
        title: 'Mr.',
        firstName: 'John',
        lastName: 'Doe',
        address: '123 Aviation Way, Some City, Some Country',
        email: 'john.doe@example.com',
        phone: '+1234567890',
        jobTitle: 'CEO',
        company: {
          name: 'Acme Aviation',
          address: '123 Aviation Way, Some City, Some Country',
          website: 'https://acmeaviation.com',
        },
      },
    ],
    aircrafts: [
      {
        aircraftID: 'AC-001',
        ownershipType: CLIENT_AIRCRAFT_OWNERSHIP_TYPES.WHOLE,
      },
    ],
  },
  {
    documentID: getClientID(2),
    primaryContact: {
      isPrimary: true,
      title: 'Ms.',
      firstName: 'Jane',
      lastName: 'Smith',
      address: '456 Aviation Blvd, Another City, Another Country',
      email: 'jane.smith@example.com',
      phone: '+1987654321',
      jobTitle: 'CTO',
      company: {
        name: 'Skyline Technologies',
        address: '456 Aviation Blvd, Another City, Another Country',
        website: 'https://skylinetech.com',
      },
    },
    contacts: [
      {
        isPrimary: true,
        title: 'Ms.',
        firstName: 'Jane',
        lastName: 'Smith',
        address: '456 Aviation Blvd, Another City, Another Country',
        email: 'jane.smith@example.com',
        phone: '+1987654321',
        jobTitle: 'CTO',
        company: {
          name: 'Skyline Technologies',
          address: '456 Aviation Blvd, Another City, Another Country',
          website: 'https://skylinetech.com',
        },
      },
      {
        isPrimary: false,
        title: 'Mr.',
        firstName: 'Paul',
        lastName: 'Adams',
        address: '789 Airspace St, Another City, Another Country',
        email: 'paul.adams@example.com',
        phone: '+1122334455',
        jobTitle: 'COO',
        company: {
          name: 'Skyline Technologies',
          address: '456 Aviation Blvd, Another City, Another Country',
          website: 'https://skylinetech.com',
        },
      },
    ],
    aircrafts: [
      {
        aircraftID: 'AC-002',
        ownershipType: CLIENT_AIRCRAFT_OWNERSHIP_TYPES.FRACTIONAL,
        fractionalData: {
          percent: 0.5,
          expiration: new Date('2024-12-31'),
        },
      },
    ],
  },
  {
    documentID: getClientID(3),
    primaryContact: {
      isPrimary: true,
      title: 'Mr.',
      firstName: 'Bob',
      lastName: 'Johnson',
      address: '101 Jetcraft Rd, A City, Country',
      email: 'bob.johnson@example.com',
      phone: '+1231231234',
      jobTitle: 'Managing Director',
      company: {
        name: 'Jetcraft',
        address: '101 Jetcraft Rd, A City, Country',
        website: 'https://jetcraft.com',
      },
    },
    contacts: [
      {
        isPrimary: true,
        title: 'Mr.',
        firstName: 'Bob',
        lastName: 'Johnson',
        address: '101 Jetcraft Rd, A City, Country',
        email: 'bob.johnson@example.com',
        phone: '+1231231234',
        jobTitle: 'Managing Director',
        company: {
          name: 'Jetcraft',
          address: '101 Jetcraft Rd, A City, Country',
          website: 'https://jetcraft.com',
        },
      },
    ],
    aircrafts: [
      {
        aircraftID: 'AC-003',
        ownershipType: CLIENT_AIRCRAFT_OWNERSHIP_TYPES.WHOLE,
      },
      {
        aircraftID: 'AC-004',
        ownershipType: CLIENT_AIRCRAFT_OWNERSHIP_TYPES.FRACTIONAL,
        fractionalData: {
          percent: 0.5,
          expiration: new Date('2024-12-31'),
        },
      },
    ],
  },
  {
    documentID: getClientID(4),
    primaryContact: {
      isPrimary: true,
      title: 'Ms.',
      firstName: 'Alice',
      lastName: 'Williams',
      address: '321 Cloud Lane, New City, Country',
      email: 'alice.williams@example.com',
      phone: '+14151234567',
      jobTitle: 'CFO',
      company: {
        name: 'Aero Finances',
        address: '321 Cloud Lane, New City, Country',
        website: 'https://aerofinances.com',
      },
    },
    contacts: [
      {
        isPrimary: true,
        title: 'Ms.',
        firstName: 'Alice',
        lastName: 'Williams',
        address: '321 Cloud Lane, New City, Country',
        email: 'alice.williams@example.com',
        phone: '+14151234567',
        jobTitle: 'CFO',
        company: {
          name: 'Aero Finances',
          address: '321 Cloud Lane, New City, Country',
          website: 'https://aerofinances.com',
        },
      },
    ],
    aircrafts: [
      {
        aircraftID: 'AC-005',
        ownershipType: CLIENT_AIRCRAFT_OWNERSHIP_TYPES.WHOLE,
      },
    ],
  },
  {
    documentID: getClientID(5),
    primaryContact: {
      isPrimary: true,
      title: 'Mr.',
      firstName: 'Michael',
      lastName: 'Brown',
      address: '654 Pilot Ave, Sky City, Country',
      email: 'michael.brown@example.com',
      phone: '+14157654321',
      jobTitle: 'Director',
      company: {
        name: 'Skyline Ventures',
        address: '654 Pilot Ave, Sky City, Country',
        website: 'https://skylineventures.com',
      },
    },
    contacts: [
      {
        isPrimary: true,
        title: 'Mr.',
        firstName: 'Michael',
        lastName: 'Brown',
        address: '654 Pilot Ave, Sky City, Country',
        email: 'michael.brown@example.com',
        phone: '+14157654321',
        jobTitle: 'Director',
        company: {
          name: 'Skyline Ventures',
          address: '654 Pilot Ave, Sky City, Country',
          website: 'https://skylineventures.com',
        },
      },
      {
        isPrimary: false,
        title: 'Ms.',
        firstName: 'Rachel',
        lastName: 'Green',
        address: '987 Flight Rd, Sky City, Country',
        email: 'rachel.green@example.com',
        phone: '+14159876543',
        jobTitle: 'Manager',
        company: {
          name: 'Skyline Ventures',
          address: '654 Pilot Ave, Sky City, Country',
          website: 'https://skylineventures.com',
        },
      },
    ],
    aircrafts: [
      {
        aircraftID: 'AC-006',
        ownershipType: CLIENT_AIRCRAFT_OWNERSHIP_TYPES.FRACTIONAL,
        fractionalData: {
          percent: 0.5,
          expiration: new Date('2024-12-31'),
        },
      },
    ],
  },
  {
    documentID: getClientID(6),
    primaryContact: {
      isPrimary: true,
      title: 'Ms.',
      firstName: 'Laura',
      lastName: 'Davis',
      address: '111 Aero Park, Metro City, Country',
      email: 'laura.davis@example.com',
      phone: '+14153456789',
      jobTitle: 'Operations Manager',
      company: {
        name: 'Aero Operations',
        address: '111 Aero Park, Metro City, Country',
        website: 'https://aeroops.com',
      },
    },
    contacts: [
      {
        isPrimary: true,
        title: 'Ms.',
        firstName: 'Laura',
        lastName: 'Davis',
        address: '111 Aero Park, Metro City, Country',
        email: 'laura.davis@example.com',
        phone: '+14153456789',
        jobTitle: 'Operations Manager',
        company: {
          name: 'Aero Operations',
          address: '111 Aero Park, Metro City, Country',
          website: 'https://aeroops.com',
        },
      },
    ],
    aircrafts: [
      {
        aircraftID: 'AC-007',
        ownershipType: CLIENT_AIRCRAFT_OWNERSHIP_TYPES.WHOLE,
      },
    ],
  },
  {
    documentID: getClientID(7),
    primaryContact: {
      isPrimary: true,
      title: 'Mr.',
      firstName: 'Robert',
      lastName: 'Miller',
      address: '222 Runway Rd, Capital City, Country',
      email: 'robert.miller@example.com',
      phone: '+14155678901',
      jobTitle: 'VP Sales',
      company: {
        name: 'Runway Sales',
        address: '222 Runway Rd, Capital City, Country',
        website: 'https://runwaysales.com',
      },
    },
    contacts: [
      {
        isPrimary: true,
        title: 'Mr.',
        firstName: 'Robert',
        lastName: 'Miller',
        address: '222 Runway Rd, Capital City, Country',
        email: 'robert.miller@example.com',
        phone: '+14155678901',
        jobTitle: 'VP Sales',
        company: {
          name: 'Runway Sales',
          address: '222 Runway Rd, Capital City, Country',
          website: 'https://runwaysales.com',
        },
      },
    ],
    aircrafts: [
      {
        aircraftID: 'AC-008',
        ownershipType: CLIENT_AIRCRAFT_OWNERSHIP_TYPES.FRACTIONAL,
        fractionalData: {
          percent: 0.5,
          expiration: new Date('2024-12-31'),
        },
      },
    ],
  },
  {
    documentID: getClientID(8),
    primaryContact: {
      isPrimary: true,
      title: 'Ms.',
      firstName: 'Emily',
      lastName: 'Wilson',
      address: '333 Sky High St, Urban City, Country',
      email: 'emily.wilson@example.com',
      phone: '+14156789012',
      jobTitle: 'Marketing Director',
      company: {
        name: 'Sky High Marketing',
        address: '333 Sky High St, Urban City, Country',
        website: 'https://skyhighmarketing.com',
      },
    },
    contacts: [
      {
        isPrimary: true,
        title: 'Ms.',
        firstName: 'Emily',
        lastName: 'Wilson',
        address: '333 Sky High St, Urban City, Country',
        email: 'emily.wilson@example.com',
        phone: '+14156789012',
        jobTitle: 'Marketing Director',
        company: {
          name: 'Sky High Marketing',
          address: '333 Sky High St, Urban City, Country',
          website: 'https://skyhighmarketing.com',
        },
      },
    ],
    aircrafts: [
      {
        aircraftID: 'AC-009',
        ownershipType: CLIENT_AIRCRAFT_OWNERSHIP_TYPES.WHOLE,
      },
    ],
  },
  {
    documentID: getClientID(9),
    primaryContact: {
      isPrimary: true,
      title: 'Mr.',
      firstName: 'David',
      lastName: 'Moore',
      address: '444 Jetway Blvd, Harbor City, Country',
      email: 'david.moore@example.com',
      phone: '+14157890123',
      jobTitle: 'Logistics Manager',
      company: {
        name: 'Jetway Logistics',
        address: '444 Jetway Blvd, Harbor City, Country',
        website: 'https://jetwaylogistics.com',
      },
    },
    contacts: [
      {
        isPrimary: true,
        title: 'Mr.',
        firstName: 'David',
        lastName: 'Moore',
        address: '444 Jetway Blvd, Harbor City, Country',
        email: 'david.moore@example.com',
        phone: '+14157890123',
        jobTitle: 'Logistics Manager',
        company: {
          name: 'Jetway Logistics',
          address: '444 Jetway Blvd, Harbor City, Country',
          website: 'https://jetwaylogistics.com',
        },
      },
    ],
    aircrafts: [
      {
        aircraftID: 'AC-010',
        ownershipType: CLIENT_AIRCRAFT_OWNERSHIP_TYPES.FRACTIONAL,
        fractionalData: {
          percent: 0.5,
          expiration: new Date('2024-12-31'),
        },
      },
    ],
  },
  {
    documentID: getClientID(10),
    primaryContact: {
      isPrimary: true,
      title: 'Ms.',
      firstName: 'Sophia',
      lastName: 'Taylor',
      address: '555 Horizon St, Coastal City, Country',
      email: 'sophia.taylor@example.com',
      phone: '+14158901234',
      jobTitle: 'Client Relations Manager',
      company: {
        name: 'Horizon Aviation',
        address: '555 Horizon St, Coastal City, Country',
        website: 'https://horizonaviation.com',
      },
    },
    contacts: [
      {
        isPrimary: true,
        title: 'Ms.',
        firstName: 'Sophia',
        lastName: 'Taylor',
        address: '555 Horizon St, Coastal City, Country',
        email: 'sophia.taylor@example.com',
        phone: '+14158901234',
        jobTitle: 'Client Relations Manager',
        company: {
          name: 'Horizon Aviation',
          address: '555 Horizon St, Coastal City, Country',
          website: 'https://horizonaviation.com',
        },
      },
      {
        isPrimary: false,
        title: 'Mr.',
        firstName: 'Mark',
        lastName: 'Anderson',
        address: '666 Altitude Ave, Coastal City, Country',
        email: 'mark.anderson@example.com',
        phone: '+14159012345',
        jobTitle: 'Assistant Manager',
        company: {
          name: 'Horizon Aviation',
          address: '555 Horizon St, Coastal City, Country',
          website: 'https://horizonaviation.com',
        },
      },
    ],
    aircrafts: [
      {
        aircraftID: 'AC-011',
        ownershipType: CLIENT_AIRCRAFT_OWNERSHIP_TYPES.WHOLE,
      },
      {
        aircraftID: 'AC-012',
        ownershipType: CLIENT_AIRCRAFT_OWNERSHIP_TYPES.FRACTIONAL,
        fractionalData: {
          percent: 0.5,
          expiration: new Date('2024-12-31'),
        },
      },
    ],
  },
];
